import { FC } from "react";

interface ShareIconSVGProps {
    className?: string;
}

const ShareIconSVG: FC<ShareIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.33301 16.0013V26.668C5.33301 27.3752 5.61396 28.0535 6.11406 28.5536C6.61415 29.0537 7.29243 29.3346 7.99967 29.3346H23.9997C24.7069 29.3346 25.3852 29.0537 25.8853 28.5536C26.3854 28.0535 26.6663 27.3752 26.6663 26.668V16.0013M21.333 8.0013L15.9997 2.66797M15.9997 2.66797L10.6663 8.0013M15.9997 2.66797L15.9997 20.0013"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ShareIconSVG;
